import type {
  RewardPoolDistributionPolicy} from '@api/types/rewardPools';
import {
  REWARD_POOL_DISTRIBUTION_POLICY
} from '@api/types/rewardPools';

type PolicyFlag =
  | 'isProRata'
  | 'isProRataKarma'
  | 'isProRataSwap'
  | 'isFcfs'
  | 'isFcfsV1'
  | 'isFcfsV2'
  | 'isRaffle'
  | 'isRaffleV1'
  | 'isRaffleV2'
  | 'isRaffleSwap'
  | 'isSwapBased';

export type PolicyFlags = Record<PolicyFlag, boolean>;

export const getDistributionPolicyFlags = (policy: RewardPoolDistributionPolicy): PolicyFlags => {
  const isFcfsV1 = policy === REWARD_POOL_DISTRIBUTION_POLICY.FCFS;
  const isFcfsV2 = policy === REWARD_POOL_DISTRIBUTION_POLICY.FCFS_V2;

  const isRaffleV1 = policy === REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE;
  const isRaffleV2 = policy === REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE_V2;
  const isRaffleSwap = policy === REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE_SWAP;

  const isProRataKarma = policy === REWARD_POOL_DISTRIBUTION_POLICY.PRO_RATA_KARMA;
  const isProRataSwap = policy === REWARD_POOL_DISTRIBUTION_POLICY.PRO_RATA_SWAP;

  return {
    isProRataKarma,
    isProRataSwap,
    isProRata: isProRataKarma || isProRataSwap,
    isFcfsV1,
    isFcfsV2,
    isFcfs: isFcfsV1 || isFcfsV2,
    isRaffleV1,
    isRaffleV2,
    isRaffleSwap,
    isRaffle: isRaffleV1 || isRaffleV2 || isRaffleSwap,
    isSwapBased: isRaffleSwap || isProRataSwap,
  };
};
